
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle } from 'lucide-react';

const SuccessMessage = () => {
  return (
    <div className="flex-grow flex items-center justify-center p-4">
      <Card className="w-full max-w-lg shadow-elevated animate-slide-up">
        <CardContent className="p-8 text-center">
          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
            <CheckCircle className="h-10 w-10 text-green-600" />
          </div>
          <h2 className="text-2xl font-bold text-brand-blue mb-4">Assessment Completed!</h2>
          <p className="text-gray-600 mb-6">
            Your responses have been submitted successfully and your personalized career guidance report has been generated.
          </p>
          <p className="text-sm text-gray-500">
            Redirecting to your results page...
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default SuccessMessage;
